// extracted by mini-css-extract-plugin
module.exports = {"organizerStats":"organizer-stats_organizerStats__3CkeW","isDownloading":"organizer-stats_isDownloading__2KUR_","isForMarketing":"organizer-stats_isForMarketing__3YFiA"};